var exports = {
  "qr": "EditingMessageInput.module__footer___MGprNk",
  "s6": "EditingMessageInput.module__footerLink___MGprNk",
  "me": "EditingMessageInput.module__separator___MGprNk",
  "EN": "EditingMessageInput.module__editor___MGprNk",
};

module.exports = exports;
